<template>
	<section>
		<div class="title-box" v-for="(item, idx) in Titles" :key="idx">
			<h3 class="title">{{item.Content}}</h3>
		</div>
	</section>
</template>

<script>
export default {
	name: 'DoubleRow',
	props: ['Titles']
}
</script>

<style lang="scss" scoped>
.title-box {
	display: -webkit-box;
	-webkit-box-align: center;
	-webkit-box-pack: justify;
	padding: 12px 0;
	margin-right: 8px;
	.title {
		display: -webkit-box; 
		line-height: 24px;
		font-size: 16px;
		color: #333;
		font-weight: bold;
		-webkit-box-flex: 1;
		-webkit-line-clamp: 2; 
		-webkit-box-orient: vertical;
		overflow: hidden; 
		text-overflow: ellipsis; 
	}
}
</style>



// WEBPACK FOOTER //
// src/template/title/DoubleRow.vue